import ServiceHighlights from "reusables/sections/ServiceHighlights";

const items = [
  {
    icon: "chair",
    title: "Carpets & Rugs",
    description:
      "We carry out hot water extraction and dry cleaning treatments to restore carpets and rugs to a clean and fresh condition.",
  },
  {
    icon: "weekend",
    title: "Sofas & Upholstery",
    description:
      "We clean sofas, armchairs, and fabric furniture using methods appropriate to the material — removing stains and odours effectively.",
  },
  {
    icon: "air",
    title: "Allergen Removal",
    description:
      "Our deep cleaning process removes dust mites, pet dander, and allergens embedded in fibres — improving air quality in your space.",
  },
  {
    icon: "home_work",
    title: "Residential & Commercial",
    description:
      "We service both domestic and commercial properties, including offices, hotels, and rental accommodations.",
  },
];

function CarpetUpholstery_Section1() {
  return <ServiceHighlights title="Why Choose Our Carpet & Upholstery Cleaning?" items={items} />;
}

export default CarpetUpholstery_Section1;
